"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { SvgIconType } from '../SvgIcon/svg-icon-type.mjs';
import { forwardRef } from 'react';
import { Tag } from '../Tag/Tag.mjs';
import '../Tag/TagPlaceholder.mjs';
import classes from './ComboBoxTag.module.css.mjs';

const ComboBoxTag = forwardRef(function({
  // Style related props
  className,
  variant = "default",
  selected = false,
  disabled,
  invalid,
  onClick,
  tooltip,
  // Nested children props
  children,
  icon,
  iconUri,
  ...props
}, ref) {
  return /* @__PURE__ */ jsxs(
    Tag,
    {
      className: clsx(
        classes.tagDefault,
        !!onClick && classes.tagDefault__clickable,
        selected && classes.tagDefault__selected,
        disabled && classes.tagDefault__disabled,
        invalid && classes.tagDefault__invalid,
        variant === "lookup" && classes.tagLookup,
        className
      ),
      tooltip,
      onClick,
      ref,
      ...props,
      children: [
        /* @__PURE__ */ jsx(ComboboxIcon, { invalid, icon, iconUri }),
        children
      ]
    }
  );
});
ComboBoxTag.displayName = "ComboBoxTag";
function ComboboxIcon({ invalid, icon, iconUri }) {
  if (invalid) {
    return /* @__PURE__ */ jsx(Tag.SvgIcon, { type: SvgIconType.Unlink });
  }
  if (icon) {
    return /* @__PURE__ */ jsx(Tag.SvgIcon, { type: icon });
  }
  if (iconUri) {
    return /* @__PURE__ */ jsx(Tag.Image, { src: iconUri });
  }
  return null;
}

export { ComboBoxTag };
